import { Navigate } from 'react-router'

import { PolicyChangeAction, PolicyChangeStatus } from '@/models/policyChange'
import { LoadedPolicyChange } from './LoadedPolicyChange'
import { PolicyChangeUpdate } from './PolicyChangeUpdate'

/** A request the broker sent back for changes, to update and send back; anything else goes to where it stands. */
export function PolicyChangeUpdatePage() {
  return (
    <LoadedPolicyChange>
      {(request, orgId) =>
        // Open while it can be edited, even with every change taken out, so the customer can add another.
        request.status === PolicyChangeStatus.NEEDS_INFO &&
        request.actions.includes(PolicyChangeAction.EDIT) ? (
          // Keyed by the ask, so a draft written for one question never goes out as the answer to the next.
          <PolicyChangeUpdate key={request.openAsk?.id ?? request.id} orgId={orgId} request={request} />
        ) : (
          <Navigate to={`/insure/policy-changes/${request.id}`} replace />
        )
      }
    </LoadedPolicyChange>
  )
}
